import { render, staticRenderFns } from "./message-sheet.vue?vue&type=template&id=49e601e7&scoped=true&"
import script from "./message-sheet.vue?vue&type=script&lang=js&"
export * from "./message-sheet.vue?vue&type=script&lang=js&"
import style0 from "./message-sheet.vue?vue&type=style&index=0&id=49e601e7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e601e7",
  null
  
)

export default component.exports